/**
 * 契約の値の月と期間。月は、サーバーとの受け渡しと比べるときは `YYYY-MM` の文字列で扱い、
 * 同じ形どうしは文字列の大小で比べる。画面で入力・表示する月は `YYYY/MM` とする。
 * 当月はサーバーが求めたものを使い、ブラウザの時計は使わない。
 */

const MONTH = /^(\d{4})-(\d{2})$/;
const MONTH_INPUT = /^(\d{4})\/(\d{2})$/;

function inRange(year: string, month: string): boolean {
  const m = parseInt(month, 10);
  return parseInt(year, 10) >= 1 && m >= 1 && m <= 12;
}

/** `YYYY-MM`（年は0001〜9999、月は01〜12）か */
export function isMonth(text: string): boolean {
  const match = MONTH.exec(text);
  return match !== null && inRange(match[1], match[2]);
}

/** 画面で入力された `YYYY/MM` の月を `YYYY-MM` にする。月でなければ null。前後の空白は除かない */
export function parseMonthInput(text: string): string | null {
  const match = MONTH_INPUT.exec(text);
  return match !== null && inRange(match[1], match[2]) ? `${match[1]}-${match[2]}` : null;
}

/** 画面に示す形（`YYYY/MM`） */
export function monthLabel(month: string): string {
  return month.replace('-', '/');
}

/** `n` か月後の月（負なら前） */
export function addMonths(month: string, n: number): string {
  const [y, m] = month.split('-').map((s) => parseInt(s, 10));
  const index = y * 12 + (m - 1) + n;
  const year = Math.floor(index / 12);
  return `${String(year).padStart(4, '0')}-${String((index % 12) + 1).padStart(2, '0')}`;
}

export interface Period {
  start_month: string;
  end_month: string | null;
}

/** 期間に月を含むか */
export function contains(period: Period, month: string): boolean {
  return period.start_month <= month && (period.end_month === null || month <= period.end_month);
}

/** 2つの期間が重なるか */
export function overlaps(a: Period, b: Period): boolean {
  return (
    (a.end_month === null || b.start_month <= a.end_month) &&
    (b.end_month === null || a.start_month <= b.end_month)
  );
}

/** 期間の表示。終了月がなければ「継続中」 */
export function formatPeriod(period: Period): string {
  const end = period.end_month === null ? '継続中' : monthLabel(period.end_month);
  return `${monthLabel(period.start_month)}〜${end}`;
}
